import { createApp } from 'vue';
import DrawerMenu from '@/js/vue/drawer-menu/components/DrawerMenu.vue';

// プラグインインスタンス参照を保持（モジュール内のプライベート変数）
let drawerMenuInstance = null;
let mountedApp = null;
let mountedElementId = null;


/**
 * DrawerMenuプラグイン
 * Vue化したDrawerMenuコンポーネントの制御を提供
 * グローバル汚染を避けるため、プラグイン経由でのアクセスを推奨
 */
const Plugin = {
    installed: false,
    /**
     * Vueアプリケーションにプラグインをインストール
     */
    install(app) {
        // 二重インストール防止
        if (Plugin.installed) return;

        // グローバルコンポーネントとして登録
        app.component('DrawerMenu', DrawerMenu);

        // Vue内からのみアクセス可能な globalProperties で公開
        app.config.globalProperties.$drawerMenu = {
            open: () => Plugin.open(),
            close: () => Plugin.close(),
            toggle: () => Plugin.toggle(),
            isMounted: () => Plugin.isMounted(),
        };

        Plugin.installed = true;

        // コンソールで確認用メッセージ
        if (import.meta.env.MODE === 'development') {
            console.log('DrawerMenuPlugin installed');
        }
    },

    /**
     * DrawerMenu を指定要素へマウント
     * @param {string} elementId
     * @param menuComponent
     */
    mount(elementId = 'drawer_menu', menuComponent = {}) {
        const el = document.getElementById(elementId);
        if (!el) {
            if (import.meta.env.VITE_APP_ENV!=='production') {
                console.warn(`[DrawerMenu] Element with id="${elementId}" not found`);
            }
            return null;
        }

        // 同一要素へ再マウントはスキップ
        if (mountedApp && mountedElementId === elementId) {
            return mountedApp;
        }

        // 異なる要素へマウントする場合は既存を解放
        if (mountedApp) {
            Plugin.unmount();
        }

        const drawerApp = createApp(DrawerMenu, {
            menuComponent: menuComponent
        });

        drawerApp.use(Plugin);
        drawerApp.mount(el);

        mountedApp = drawerApp;
        mountedElementId = elementId;

        if (import.meta.env.DEV) {
            console.debug(`[DrawerMenu] Mounted on #${elementId}`);
        }

        return drawerApp;
    },

    /**
     * マウント済み DrawerMenu を解放
     */
    unmount() {
        if (!mountedApp) return;
        mountedApp.unmount();
        mountedApp = null;
        mountedElementId = null;
        drawerMenuInstance = null;
    },

    /**
     * DrawerMenuコンポーネント参照を登録
     * @param {Object} instance - DrawerMenuコンポーネント参照
     */
    setInstance(instance) {
        drawerMenuInstance = instance ?? null;
    },

    /**
     * DrawerMenuコンポーネントが実際にマウントされているか
     * */
    isMounted() {
        return !!drawerMenuInstance;
    },

    /**
     * ドロワーメニューを開く
     */
    open() {
        if (drawerMenuInstance) {
            drawerMenuInstance.open();
        }
    },

    /**
     * ドロワーメニューを閉じる
     */
    close() {
        if (drawerMenuInstance) {
            drawerMenuInstance.close();
        }
    },

    /**
     * ドロワーメニューをトグル
     */
    toggle() {
        if (drawerMenuInstance) {
            drawerMenuInstance.toggle();
        }
    }
};

export default Plugin;

